import React, { Component } from 'react';
import { Toggle } from 'redux-form-material-ui';
import { Field } from 'redux-form';

class PreferenceField extends Component {
  render() {
    let {
      toggleValue,
      toggleName,
      toggleLabelName,
      preferenceDescription,
      children,
      onChange,
      shouldHide,
      ...otherProps
    } = this.props;

    if (this.props.shouldHide) return null;

    return (
      <div
        style={{
          marginBottom: '15px',
          borderBottom: '1px solid rgba(0,0,0,0.1)',
          ...this.props.rootStyle,
        }}
      >
        <div>
          <Field
            name={toggleName}
            component={Toggle}
            label={
              <strong style={{ fontWeight: '900', fontSize: '16px' }}> {toggleLabelName} </strong>
            }
            style={{ textAlign: 'initial' }}
            onChange={onChange}
            {...otherProps}
            parse={value => !!value}
          />
        </div>
        <div style={{ textAlign: 'initial', maxWidth: '500px' }}>
          <p> {preferenceDescription} </p>
        </div>
        <div style={{ textAlign: 'left', marginTop: '25px', marginBottom: '5px' }}>
          {toggleValue && children}
        </div>
      </div>
    );
  }
}

export default PreferenceField;
